import classNames from 'classnames'

import HeadlineFour from 'ui-component-library/components/00-Primitives/Headlines/HeadlineFour'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import Ruler from 'ui-component-library/components/00-Primitives/Ruler'
import Button from 'content-components/_Primatives/Button'
import useSticky from '../useSticky'
import baseStyle from '../style.scss'
import style from './style.scss'

type Props = {
  bodyText: string
  headlineText: string
  alreadyRegisteredText: string
  alreadyRegisteredLinkUrl: string
  alreadyRegisteredLinkText: string
}

function AlreadyRegisteredCTA({
  bodyText,
  headlineText,
  alreadyRegisteredText,
  alreadyRegisteredLinkUrl,
  alreadyRegisteredLinkText,
}: Props) {
  const { stickyRef, isSticky } = useSticky<HTMLDivElement>(130)
  return (
    <div
      className={classNames(baseStyle.wrapper, {
        [baseStyle.stickyWrapper]: isSticky,
      })}
    >
      <div className={baseStyle.content}>
        <HeadlineTwo className={baseStyle.headlineText}>
          {headlineText}
        </HeadlineTwo>
        <Ruler className={baseStyle.ruler} />
        <Paragraph className={baseStyle.bodyText}>{bodyText}</Paragraph>
      </div>
      <div
        ref={stickyRef}
        className={classNames(baseStyle.ctaWrapper, {
          [baseStyle.sticky]: isSticky,
        })}
      >
        <HeadlineFour
          className={classNames(baseStyle.ctaHeadline, style.ctaHeadline)}
        >
          {alreadyRegisteredText}
        </HeadlineFour>
        <Button
          target='_self'
          className={baseStyle.ctaButton}
          url={alreadyRegisteredLinkUrl}
        >
          {alreadyRegisteredLinkText}
        </Button>
      </div>
    </div>
  )
}

export default AlreadyRegisteredCTA
